import React from 'react';
import { Col } from '@tencent/tea-component';
import HostStatus from '@asset/image/user/host_status@2x.png';
import CoStatus from '@asset/image/user/co_host_status@2x.png';
import MicState from '@component/mic-state';
import PhoneState from '@component/phone-state';
import { VideoPrefix } from '@constant/media';
import Avatar from '@component/avatar';
import { useAudioLevel } from '@utils/hooks/useAudioLevel';
import { BOOL, RoleType, WeMeetClient } from '@tencent/wemeet-websdk-next';
import { AudioBlockProps } from './AudioBlock.type';
import './AudioBlock.scss';
import { isUserAudioOn } from '@utils/helper/media';
import { isMobileBrowser } from '@utils/browser';

const isPhone = isMobileBrowser();
const AudioBlock: React.FC<AudioBlockProps> = ({ user }) => {
  const audioLevel = useAudioLevel(user?.rtcStream?.stream, false);
  return (
    <Col span={isPhone ? 8 : 4}>
      <div
        className={`audio-block ${audioLevel > 0 && isUserAudioOn(user) ? 'audio-block--saying' : ''} ${
          isPhone ? 'audio-block-phone' : ''
        }`}
      >
        <Avatar
          avatarType={user?.avatar_type}
          mode="large"
          avatarToken={user?.avatar_token}
          userDistrict={user?.user_district}
          nickname={user?.nickname}
        />
        {WeMeetClient.utils.isHost(user) && <img src={HostStatus} alt="host" className="audio-block__host" />}
        {user.role_type === RoleType.coHost && <img src={CoStatus} alt="cohost" className="audio-block__host" />}
        <div className="audio-block__user">
          <div className="audio-block__user__nickname">{user.nickname}</div>
          {user?.isPhoneUser ? (
            <PhoneState
              mode="blue"
              on={user?.up_audio_on?.__value === BOOL.true}
              ableOuterLevel
              outerLevel={audioLevel}
            />
          ) : (
            <MicState
              mode="blue"
              micOn={user?.up_audio_on?.__value === BOOL.true}
              ableOuterLevel
              outerLevel={audioLevel}
            />
          )}
        </div>
        {user?.up_audio_on?.__value === BOOL.true && (
          // 其实音频已经通过stream.play播放，这里可以不加，重复播放的时候，可以使用play之后创造的audio播放
          <video
            ref={(el) => {
              if (el) {
                // eslint-disable-next-line no-param-reassign
                el.id = `${VideoPrefix.audio}-${user?.rtcStream?.videoId ?? ''}`;
                // eslint-disable-next-line no-param-reassign
                el.srcObject = user?.rtcStream?.stream?.mediaStream_;
              }
            }}
            autoPlay
            muted={true}
            playsInline
            className="audio-block__video"
            onContextMenu={() => {}}
            // id={item?.rtcStream?.videoId}
            // @ts-ignore
            type={user?.rtcStream?.streamType}
          />
        )}
      </div>
    </Col>
  );
};

export default AudioBlock;
